<template>
  <!-- 中耳报告  -->
  <div v-if="model && model.middleEar">
    <div id="print_middleEar" class="page middleEar-page" style="margin:0 auto; border:0px solid #E8E8EC;">
      <div style="height: 50px;"></div>
      <div style="font-size: 18px;"><span>{{ model.middleEar.hospitalName ? model.hospitalName : "" }}</span></div>
      <div style="font-size: 22px;padding: 20px 0 30px 0;font-weight: 600;"><span>{{ model.middleEar.reportName ? model.middleEar.reportName : "中耳筛查报告" }}</span></div>

      <table style="margin-top: 15px;text-align: left;width: 100%;border-collapse: collapse;border:none;border-bottom:1px solid #0E0E0EFF;">
        <tbody>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;">姓名：<span>{{ model.middleEar.name ? model.middleEar.name : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">性别：<span>{{ model.middleEar.sex ? model.middleEar.sex : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">年龄：<span>{{ model.middleEar.age ? model.middleEar.age : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <table style="margin-top: 10px;width: 100%;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;">
              <div><p style="font-size: 23px;font-weight: bold;">结果</p></div>
              <div style="min-height: 50px;"><p><span>{{ model.middleEar.result ? model.middleEar.result : "" }}</span></p></div>
            </td>
          </tr>
          <tr style="text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;">
              <div><p style="font-size: 23px;font-weight: bold;">建议</p></div>
              <div style="min-height: 50px;"><p><span>{{ model.middleEar.proposal ? model.middleEar.proposal : "" }}</span></p></div>
            </td>
          </tr>
        </tbody>
      </table>

      <table style="margin-top: 30px;text-align: left;width: 100%;border-collapse: collapse;border:none;border-top:1px solid #0E0E0EFF;">
        <tbody>
          <tr style="width: 100%;border-collapse: collapse;text-align: left;border:none;line-height: 30px;">
            <td style="width: 80%;border-collapse: collapse;border:none;">医生：<img :src="model.middleEar.doctorSignature" style="height: 40px;width: 100px;object-fit: contain;" v-if="model.middleEar.doctorSignature"></td>
            <td style="border-collapse: collapse;border:none;">日期：<span>{{ model.middleEar.screeningDate ? model.middleEar.screeningDate : "" }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>
<script>

import {_middleEar} from "@/services/report/report";
export default {
  name: "middleEarReport",
  props: {
    physicalId: [String, Number],
    barCode: [String, Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        middleEar:{
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    }
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'middleEar'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'middleEar') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods: {
    loadData(){
      if(this.barCode){
        this.middleEar(this.barCode);
      }
    },
    middleEar(barCode) {
      _middleEar({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
      })
    },
  }
};
</script>
<style lang="postcss" scoped>
@media print {
  .middleEar-page {
    page: middleEar-page; /* 绑定唯一命名 */
  }
  @page middleEar-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;text-align: center;margin:0 auto;padding-top:10px;padding-left:40px;padding-right:40px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff;}

</style>
